import { Button, FormControl, Grid, InputLabel, MenuItem, Select, Snackbar, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonCancel, ButtonContinue, FieldWrapper } from '../../../components/general/mini_components';
import PatientInfo from '../../../components/PatientInfo';
import { AgendasTypes, IAgenda, IAppointment, IDepartment } from '../../../constants/types';
import AppointmentDatePicker from './DatePicker';
import { usePrevious, useSnackBarState } from '../../../hooks';
import Typography from '@mui/material/Typography';
import Loader from '../../../components/Loader';
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';


import { connect} from 'react-redux';
import { Alert } from '@mui/material';
import { isArray } from 'lodash';
import { makeAppointmentService } from '../../../services';
import { TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { errorCodesCreateAppointment, turnsAgendaDates } from '../../../utils/agenda';
import { turnsToSchedule } from '../../../utils';
import { useAgendas } from '../../../hooks/agenda';
import { ExtraAppointmentInfo } from './Appointments/NewAppointment';
import { IRequest } from '../Request/types';

interface ExtraAppointmentData {
    idService : number, 
    reason: string, 
    notes:string
}

interface FormAppointmentGeneralProps extends LocalizeContextProps {
    uuidPatient?: string;
    uuidInvestigation:string,
    hospital?: any,
    typeAgenda:AgendasTypes,
    mode: 'make' | 'consult',
    hidePatientInfo?: boolean,
    showAllAgendas:boolean,
    dateTimeAppointment?:boolean,
    appointment?:IAppointment | null,
    phoneNumber? : boolean,
    extraForm?: number,
    department?: IDepartment,
    appointmentMadeCallback?: (appointment:IAppointment) => void;
    infoAppointmentReadyCallback?:(uuidAgenda:string[], date:Date) => void;
    agendaChangedCallback?:(uuidAgendas: string[]) => void;
    cancelCallback?: () => void;
}

interface FormMakeAppointmentProps {
    uuidPatient: string;
    request?: IRequest,
    uuidInvestigation:string,
    typeAgenda:AgendasTypes,
    department?: IDepartment,
    showAllAgendas:boolean,
    hidePatientInfo?: boolean,
    dateTimeAppointment:boolean,
    phoneNumber : string,
    extraForm?: number,
    appointmentMadeCallback: (appointment:IAppointment) => void;
    cancelCallback: () => void;
}

interface FormConsultAppointmentProps {
    uuidInvestigation:string,
    typeAgenda:AgendasTypes,
    showAllAgendas:boolean,
    dateTimeAppointment:boolean,
    appointment:IAppointment | null,
    infoAppointmentReadyCallback:(uuidAgenda:string[], date:Date) => void;
    agendaChangedCallback?:(uuidAgendas: string[]) => void;
}

export const FormConsultAppointment: React.FC<FormConsultAppointmentProps> = ({ uuidInvestigation, showAllAgendas, appointment, dateTimeAppointment, typeAgenda,
                                                                                    infoAppointmentReadyCallback, agendaChangedCallback }) => {
    
    return <FormAppointmentGeneralConnected uuidInvestigation={uuidInvestigation} mode='consult' showAllAgendas={showAllAgendas}
                dateTimeAppointment={dateTimeAppointment} typeAgenda={typeAgenda}
                appointment={appointment}
                infoAppointmentReadyCallback={infoAppointmentReadyCallback} 
                agendaChangedCallback={agendaChangedCallback} />
};

export const FormMakeAppointment: React.FC<FormMakeAppointmentProps> = ({ uuidPatient, showAllAgendas, department, dateTimeAppointment, typeAgenda, request,
                                                                            extraForm, uuidInvestigation, hidePatientInfo, phoneNumber, appointmentMadeCallback, cancelCallback }) => {
    
    return <FormAppointmentGeneralConnected showAllAgendas={showAllAgendas} uuidInvestigation={uuidInvestigation} uuidPatient={uuidPatient} mode='make'
                hidePatientInfo={hidePatientInfo} department={department} dateTimeAppointment={dateTimeAppointment} phoneNumber={phoneNumber}
                typeAgenda={typeAgenda}
                extraForm={extraForm} request={request}
                appointmentMadeCallback={appointmentMadeCallback} cancelCallback={cancelCallback} />
};

const FormAppointmentGeneral: React.FC<FormAppointmentGeneralProps> = ({ uuidInvestigation, department, uuidPatient, mode, hospital, hidePatientInfo, showAllAgendas, 
                                                                            dateTimeAppointment, phoneNumber, extraForm, typeAgenda, appointment, request,
                                                                            appointmentMadeCallback, infoAppointmentReadyCallback, agendaChangedCallback,
                                                                            cancelCallback, translate }) => {
    const {agendas, loadingAgendas} = useAgendas(typeAgenda);
    //const appointments =  useSelector((state:any) => state.hospital.data.appointments);
    const [appointments, setAppointments] = useState<IAppointment[] | null>(null);
    const [departmentsWithAgenda, setDepartmentsWithAgenda] = useState<IDepartment[]>([]);
    const prevAppointments:IAppointment[] | null = usePrevious(hospital.data.appointments);
    const [appointmentCreated, setAppointmentCreated] = useState<boolean | IAppointment>(false);
    const [error, setError] = useState<number>(-1);
    const [loading, setLoading] = useState<boolean>(false);

    function makeAppointment(uuidAgenda:string, date:Date, makeAppointmentData: ExtraAppointmentData){
        setLoading(true);
        setError(-1);
        makeAppointmentService(uuidInvestigation, typeAgenda, uuidAgenda, uuidPatient, date, makeAppointmentData.idService, phoneNumber, makeAppointmentData.reason, makeAppointmentData.notes)  
            .then((response) => {
                const tempAppointments = appointments ? [...appointments] : [];
                tempAppointments.push(response.appointment);
                setAppointments(tempAppointments);
                setAppointmentCreated(response.appointment);
                setLoading(false);
            })
            .catch((error) => { 
                setAppointmentCreated(false);
                setError(error.errorCode);
                setLoading(false);
            });
    }

    function infoAppointmentReady(uuidAgendas:string[], date:Date, makeAppointmentData?: ExtraAppointmentData){
        if(appointmentMadeCallback){
            makeAppointment(uuidAgendas[0], date, makeAppointmentData)
        }
        else if(infoAppointmentReadyCallback){
            infoAppointmentReadyCallback(uuidAgendas, date);
        }
    }

    useEffect(() => {
        if(agendas){
            const departmentsDict:{[uuidDepartment:string]:IDepartment} = {};
            agendas.forEach((agenda) => {
                if(agenda.department){
                    const uuidDepartment = agenda.department.uuid as string;
                    departmentsDict[uuidDepartment] = agenda.department;
                }
            });
            if(department){
                if(departmentsDict[department.uuid as string]){
                    setDepartmentsWithAgenda([department]);
                }
            }
            else{
                const departmentsWithAgenda:IDepartment[] = Object.values(departmentsDict);
                setDepartmentsWithAgenda(departmentsWithAgenda);
            }
        }
        
    }, [agendas]);

    useEffect(() => {
        
        if((!prevAppointments && isArray(appointments) && appointmentCreated && appointmentMadeCallback) || 
            (isArray(prevAppointments) && isArray(appointments) && prevAppointments.length < appointments.length && appointmentMadeCallback)){
            
            setTimeout(() => {
                appointmentMadeCallback(appointmentCreated as IAppointment);
            }, 2000);   
        }
    }, [appointments, appointmentCreated]);

    

    if(loadingAgendas || hospital.loading){
        return <Loader />
    }
    else if(agendas !== null){
        return (
            <>
                <FormAppointmentCore uuidPatient={uuidPatient} departmentsWithAgenda={departmentsWithAgenda} 
                    error={error } mode={mode} showAllAgendas={showAllAgendas} dateTimeAppointment={Boolean(dateTimeAppointment)}
                    loading={loading} hidePatientInfo={hidePatientInfo}
                    appointment={appointment} typeAgenda={typeAgenda} request={request}
                    appointmentCreated={Boolean(appointmentCreated)} extraForm={extraForm}
                    agendas={agendas} infoAppointmentCallback={infoAppointmentReady}
                    agendaChangedCallback={agendaChangedCallback}
                    cancelCallback={cancelCallback}
                    translate={translate} />
            </>
        );
    }
    else{
        return <Typography>There are no agendas</Typography>
    }
    
};

const mapStateToProps = (state:any) =>{
    return {
        hospital:state.hospital, 
        investigations:state.investigations
    }
}

const FormAppointmentGeneralConnected = withLocalize(connect(mapStateToProps, null)(FormAppointmentGeneral));

interface FormAppointmentCoreProps extends LocalizeContextProps, Omit<FormAppointmentGeneralProps, 'makeAppointmentAction' | 'appointmentMadeCallback' | 'uuidInvestigation' | 'hospital'> {
    departmentsWithAgenda:IDepartment[];
    agendas:IAgenda[];
    error:number;
    request?: IRequest;
    typeAgenda:AgendasTypes;
    showAllAgendas:boolean;
    dateTimeAppointment:boolean;
    hidePatientInfo?:boolean,
    loading:boolean;
    extraForm?:number;
    appointmentCreated:boolean;
    infoAppointmentCallback: (uuidAgendas: string[], date: Date, makeAppointmentData?: ExtraAppointmentData) => void;
    cancelCallback: () => void;
}

export const FormAppointmentCore: React.FC<FormAppointmentCoreProps> = ({ uuidPatient, loading, showAllAgendas, dateTimeAppointment, extraForm,
                                                                            appointment, typeAgenda, request, translate,
                                                                            departmentsWithAgenda, hidePatientInfo, agendas, mode, error, appointmentCreated, 
                                                                            infoAppointmentCallback, agendaChangedCallback, cancelCallback }) => {
    const [department, setDepartment] = useState<IDepartment | null>(null);
    const [errorState, setErrorState] = useState<{department:boolean, agenda:boolean, service:boolean, date:boolean}>({department:false, agenda:false, date:false, service:false});
    const [listAgendas, setListAgendas] = useState<IAgenda[]>([]); 
    const [showSnackbar, setShowSnackbar, handleCloseSnackbar] = useSnackBarState();
    const [agendasSelected, setAgendasSelected] = useState<IAgenda[]>([]);
    const now = new Date();
    now.setHours(0,0,0,0);
    const [timeSelected, setTimeSelected] = useState<Date>(now);
    const [date, setDate] = useState<Date | null>(null);
    const [service, setService] = useState<number | null>(null);
    const [reason, setReason] = useState<string>("");
    const [notes, setNotes] = useState<string>("");
    const [agendaSelected, setAgendaSelected] = useState<IAgenda | null>(null);

    useEffect(() => {
        if(agendasSelected.length > 1){
            const daysWeek = agendasSelected.flatMap(agenda => agenda.daysWeek);
            const slotsPerDay = agendasSelected.reduce((acc, agenda) => acc + agenda.slotsPerDay, 0);
            const blockedDates = agendasSelected.flatMap(agenda => agenda.blockedDates);
            const newAgenda = {...agendasSelected[0], daysWeek, slotsPerDay, blockedDates};
            setAgendaSelected(newAgenda);
        }
        else{
            setAgendaSelected(agendasSelected.length === 1 ? agendasSelected[0] : null);
        }
        
    }, [agendasSelected]);
    
    useEffect(() => {
        if(agendaSelected && !service && agendaSelected.listServicesInvestigation.length === 1){
            setService(agendaSelected.listServicesInvestigation[0].id);
        }
    }, [agendasSelected]);

    useEffect(() => {
        if (agendaChangedCallback) {
            agendaChangedCallback(agendasSelected.map((agenda) => agenda.uuid));
        }
    }, [agendaSelected])

    function renderDepartments(){
        if(departmentsWithAgenda.length === 0){
            return  null;
        }
        else if(departmentsWithAgenda.length === 1){
            return (
                <>
                    <Typography variant="body2">Department: </Typography>{departmentsWithAgenda[0].name}
                </>)
        }
        else {
            const optionsArray = departmentsWithAgenda.sort((a, b) => a.name.localeCompare(b.name)).map((department) => {
                return <MenuItem key={department.uuid} value={department.uuid}>{department.name}</MenuItem>
            })
            return (
                <FieldWrapper noWrap ={null}>
                    <FormControl fullWidth variant="outlined" margin="dense" error={errorState.agenda} >
                        <InputLabel id="agenda">{translate("pages.hospital.outpatients.agenda.select_department")}</InputLabel>
                        <Select
                            labelId="department"
                            id="department"
                            style={{width: '400px'}}
                            label={translate("pages.hospital.outpatients.agenda.select_department")}
                            onChange={(event) => {
                                const uuidDepartment = event.target.value as string;
                                const department = departmentsWithAgenda.find((department) => department.uuid === uuidDepartment);
                                if(department){
                                    setDepartment(department);
                                    setAgendasSelected([]);
                                    setDate(null);
                                    setService(null);
                                }
                            }}
                        >
                        { optionsArray }
                        </Select>
                    </FormControl>
                </FieldWrapper>
            )
        }
    }

    function updateDateTime(dateSelected:Date, time:Date){
        if(dateTimeAppointment){
            // Combine date and time
            const combined = new Date(dateSelected);
            combined.setHours(time.getHours(), time.getMinutes());
            dateSelected = combined;
        }
        setDate(dateSelected);
    }
    function onDateChange(dateSelected:Date, time:Date){
        if(dateSelected !== null){
            updateDateTime(dateSelected, time);
            if(mode === 'consult'){
                const uuidsAgendas = agendasSelected ? agendasSelected.map((agenda) => agenda.uuid) : [];
                infoAppointmentCallback(uuidsAgendas, dateSelected);
            }
        }
    }

    function renderCalendar(){
        if(((service || typeAgenda === AgendasTypes.SURGERY) && mode === 'make' && agendaSelected) || (agendaSelected && mode === 'consult')){
            
            const timePicker = <FormControl fullWidth variant="outlined" margin="dense"  >
                                    <FieldWrapper noWrap ={null}>
                                    <TimePicker
                                        label={<Translate id="pages.hospital.outpatients.agenda.select_time" />}
                                        value={dayjs(timeSelected)}
                                        ampm={false}
                                        // shouldDisableTime={(timeValue, clockType) => {
                                        //     if(clockType === 'hours'){
                                        //         return timeValue.hour() < turnsDates[0].getHours() || timeValue.hour() > turnsDates[1].getHours();    
                                        //     }
                                        //     //return timeValue.minute() < turnsDates[0].getMinutes() || timeValue.minute() > turnsDates[1].getMinutes();
                                            
                                        // }}
                                        onChange={(newValue) => {
                                            updateDateTime(date, newValue.toDate())}}
                                    />
                                    <Typography variant="body2">
                                        <Translate id="pages.hospital.outpatients.agenda.schedule" />:&nbsp;
                                        {turnsToSchedule(agendaSelected!.turn)}
                                    </Typography>
                                </FieldWrapper>
                                </FormControl>
            return (
                <Grid container xs={12}>
                    { dateTimeAppointment && mode === 'make' &&
                        <Grid item xs={12}>     
                            { timePicker }
                        </Grid>
                    }
                    <Grid item xs={4}>
                        <FormControl fullWidth variant="outlined" margin="dense"  >
                            <AppointmentDatePicker 
                                availableDaysWeek = {agendaSelected!.daysWeek} 
                                blockedDates={agendaSelected!.blockedDates} 
                                autoCurrentDate={true}
                                slotsPerDay={agendaSelected!.slotsPerDay} 
                                initialDate={appointment?.startDateTime}
                                datesOccupancy={agendaSelected!.datesOccupancy} 
                                onDateChangeCallback={(dateSel:Date) => {
                                    onDateChange(dateSel, timeSelected);
                                }} 
                            />
                            
                        </FormControl>
                    </Grid>
                    {
                        renderExtraInfo()
                    }
                </Grid>
            )
        }
    }

    function renderExtraInfo(){
        if((service && mode !== 'consult' )){
            return (
                <ExtraAppointmentInfo
                    extraForm={extraForm}
                    reason={reason}
                    setReason={setReason}
                    notes={notes}
                    setNotes={setNotes}
                />
              );
        }
        
    }
    function renderServices(){
        if(!agendaSelected || mode === 'consult' || typeAgenda === AgendasTypes.SURGERY){
            return null;
        }
        if(agendaSelected!.listServicesInvestigation.length === 0){
            return <Typography variant="body2"><Translate id="pages.hospital.outpatients.form_appointment.no-services" /></Typography>
        }
        const optionsArray = agendaSelected!.listServicesInvestigation.sort((a, b) => a.description.localeCompare(b.description)).map((service) => {
            return (
                <MenuItem value={service.id}>{service.description}</MenuItem>
            )
        });
        
        return (
            <FieldWrapper noWrap ={null}>
                <FormControl fullWidth variant="outlined" margin="dense" error={errorState.agenda} >
                    <InputLabel id="service"><Translate id="pages.hospital.outpatients.form_appointment.service" /></InputLabel>
                    <Select disabled={department === null && departmentsWithAgenda.length > 0}
                        labelId="service"
                        id="service"
                        label="Select service"
                        onChange={(event) => {
                            const idService = event.target.value as string;
                            const service = agendaSelected!.listServicesInvestigation.find((service) => service.id === idService);
                            if(service){
                                setService(service);
                            }
                        }}
                    >
                    { optionsArray }
                    </Select>
                </FormControl>
            </FieldWrapper>
        );
    }
    function renderAgendas(){
        if(listAgendas.length === 0){
            return null;
        }
        else if(listAgendas.length === 1){
            return(
                <>
                    <Typography variant="body2"><Translate id="pages.hospital.outpatients.form_appointment.agenda" />: </Typography>{listAgendas[0].name}
                </>
            );
        }
        else{
            let optionsArray = listAgendas.sort((a, b) => a.name.localeCompare(b.name)).map((agenda) => {
                return (
                    <MenuItem value={agenda.uuid}>{agenda.name}</MenuItem>
                )
            });
            if(dateTimeAppointment && mode ==='consult'){
                optionsArray.unshift(<MenuItem value="all"><Translate id="pages.hospital.outpatients.form_appointment.select_all_agendas" /></MenuItem>);
            }            
            return (
                <FieldWrapper noWrap ={null}>
                    <FormControl fullWidth variant="outlined" margin="dense" error={errorState.agenda} >
                        <InputLabel id="agenda"><Translate id="pages.hospital.outpatients.form_appointment.select_agenda" /></InputLabel>
                        <Select disabled={department === null && departmentsWithAgenda.length > 0}
                            labelId="agendas"
                            id="agendas"
                            label={translate("pages.hospital.outpatients.form_appointment.select_agenda")}
                            value={agendasSelected.length === 1 ? agendasSelected[0].uuid : ''}
                            onChange={(event) => {
                                const uuidAgenda = event.target.value as string;
                                if(dateTimeAppointment && uuidAgenda === "all"){
                                    setAgendasSelected(listAgendas);
                                    setDate(null);
                                }
                                const agenda = listAgendas.find((agenda) => agenda.uuid === uuidAgenda);
                                if(agenda){
                                    setAgendasSelected([agenda]);
                                    setDate(null);
                                }
                            }}
                        >
                        { optionsArray }
                        </Select>
                    </FormControl>
                </FieldWrapper>
            );
        }
        
    }

    function confirm(){
        console.log("Note", notes);
        console.log("Reason", reason);
        if(department === null && departmentsWithAgenda.length > 0){
            setErrorState({...errorState, department:true});
        }
        else if(!agendaSelected){
            setErrorState({...errorState, agenda:true});
        }
        else if(!service){
            setErrorState({...errorState, service:true});
        }
        else if(!date){
            setErrorState({...errorState, date:true});
        }
        if(agendaSelected && date){
            const uuidAgendas = agendasSelected.map((agenda) => agenda.uuid)
            let makeAppointmentData;
            if(typeAgenda === AgendasTypes.CONSULTATION){
                makeAppointmentData = {idService: service!.id, reason, notes: notes};
            }
            else if(typeAgenda === AgendasTypes.SURGERY && request){
                makeAppointmentData = {idService: request.id, reason, notes: notes};
            }
            infoAppointmentCallback(uuidAgendas, date, makeAppointmentData);
        }
    }

    useEffect(() => {
        if(error !== -1){
            setShowSnackbar({show:true, message:errorCodesCreateAppointment(error), severity:"error"});
        }
        else if(appointmentCreated){
            setShowSnackbar({show:true, message:`pages.hospital.outpatients.appointment.success`, severity:"success"});            
        }
        
    }, [error, appointmentCreated]);

    useEffect(() => {
        if(listAgendas.length === 1){
            setAgendasSelected(listAgendas);
        }
    }, [listAgendas])

    useEffect(() => {
        if (appointment && listAgendas.length > 0) {
            const appointmentAgenda = listAgendas.find(agenda => agenda.uuid === appointment.agenda.uuid);
            if (appointmentAgenda) {
                setAgendasSelected([appointmentAgenda]);
                setAgendaSelected(appointmentAgenda);
                // Set the date from the appointment
                const appointmentDate = new Date(appointment.startDateTime);
                setDate(appointmentDate);
                setTimeSelected(appointmentDate);
            }
        }
    }, [appointment, listAgendas]);

    useEffect(() => {
        if(!showAllAgendas && department){
            const agendasFromDepartment = agendas.filter((agenda) => (agenda.department  as IDepartment).uuid === department.uuid);
            setListAgendas(agendasFromDepartment);
        }
        else{
            setListAgendas(agendas);
        }
    }, [department])

    useEffect(() => {
        if(departmentsWithAgenda.length === 1){
            setDepartment(departmentsWithAgenda[0]);
        }
    }, [departmentsWithAgenda])

    useEffect(() => {
        if(departmentsWithAgenda.length === 0){
            const agendasNoDepartment = agendas.filter((agenda) => agenda.department === null);
            setListAgendas(agendasNoDepartment);
        }
        else{
            
        }
    }, [])

    function renderButtons(){
        if(mode === "make" && !loading && !appointmentCreated && (department && departmentsWithAgenda.length > 0) || (!department && departmentsWithAgenda.length === 0)){
            return (
                <Grid item xs={12} style={{paddingTop:'1rem'}}>
                    <ButtonCancel onClick={cancelCallback} data-testid="cancel-modal"  spaceright={1}>
                        <Translate id="general.cancel" />
                    </ButtonCancel>
                    &nbsp;
                    <ButtonContinue onClick={confirm} data-testid="continue-modal"  >
                        <Translate id="general.continue" />
                    </ButtonContinue>
                </Grid>
            )
        }
        else if(mode === "make" && loading){
            return (
            <Grid item xs={12} style={{paddingTop:'1rem'}}>
                    <Loader />
            </Grid>);
        }
        
    }
    
    return (
        <>
            <Snackbar
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                open={showSnackbar.show}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}>
                   <Alert onClose={() => setShowSnackbar({show:false})} severity={showSnackbar.severity}>
                        <Translate id={showSnackbar.message} />                            
                    </Alert>
                    
                </Snackbar>

                <Grid container spacing={1}>
                    { (uuidPatient && !hidePatientInfo) &&
                        <Grid item xs={12}>
                            <PatientInfo uuidPatient={uuidPatient} />
                        </Grid>
                    }
                    
                    <Grid item xs={12}>
                    {
                        renderDepartments()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderAgendas()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderServices()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderCalendar()
                    }
                    </Grid>
                    
                    {
                        renderButtons()
                    }
                   
                </Grid>
        </>
        
    );
};

export default FormAppointmentGeneralConnected;